import React, { Component } from "react";
import "./style.css";
class ListErrorPrompt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
  }
  render() {
    const { imgSrc, toptext, bottomtext } = this.props;
    return (
      <div
        style={{
          minHeight: this.state.css.minHeight,
        }}
        className="listErrorPrompt_box"
      >
        <img
          style={{
            marginTop: this.state.css.marginTop,
          }}
          alt=""
          src={imgSrc}
        ></img>
        <div
          dangerouslySetInnerHTML={{ __html: toptext }}
          className="listErrorPrompt_box_toptext"
        ></div>
        <div
          dangerouslySetInnerHTML={{ __html: bottomtext }}
          className="listErrorPrompt_box_bottomtext"
        ></div>
      </div>
    );
  }
  fixCss = () => {
    let minHeight = window.innerHeight - 47 - 75;
    this.setState({
      css: {
        minHeight: minHeight,
        marginTop: minHeight * 0.2,
      },
    });
  };
}

export default ListErrorPrompt;



// WEBPACK FOOTER //
// ./src/components/ListErrorPrompt/index.js